import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, TagIcon } from 'lucide-react';
interface ProductCardProps {
  image: string;
  title: string;
  description: string;
  price: string;
  comparePrice?: string;
  rating?: number;
  reviews?: number;
  buttonText?: string;
  href?: string;
}
export function ProductCard({
  image,
  title,
  description,
  price,
  comparePrice,
  rating = 4.9,
  reviews = 3779,
  buttonText = 'Agregar a mi colección →',
  href
}: ProductCardProps) {
  const discount = comparePrice ? Math.round((parseFloat(comparePrice.replace('$', '')) - parseFloat(price.replace('$', ''))) / parseFloat(comparePrice.replace('$', '')) * 100) : null;
  return <motion.article className="bg-white rounded-xl overflow-hidden border border-[#E8E0D8] hover:shadow-[0_8px_30px_rgba(255,255,255,0.1)] transition-all duration-300 flex flex-col group h-full" whileHover={{
    y: -4
  }} transition={{
    duration: 0.25
  }} data-id="element-19">
      {/* Image Container */}
      <div className="relative aspect-square overflow-hidden bg-[#FAF5EF]" data-id="element-20">
        <img src={image} alt={title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-21" />
        {discount && <div className="absolute top-3 left-3 bg-[#C17F3E] text-white px-2.5 py-1 rounded-md text-xs font-bold flex items-center gap-1 shadow-sm" data-id="element-22">
            <TagIcon className="w-3 h-3" aria-hidden="true" data-id="element-23" />-{discount}% OFF
          </div>}
      </div>

      {/* Content */}
      <div className="p-5 flex flex-col flex-1" data-id="element-24">
        {/* Rating */}
        <div className="flex items-center gap-1.5 mb-3" data-id="element-25">
          <div className="flex items-center" data-id="element-26">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className={`w-3.5 h-3.5 ${i < Math.floor(rating) ? 'text-[#C17F3E] fill-[#C17F3E]' : 'text-[#E8E0D8] fill-[#E8E0D8]'}`} aria-hidden="true" data-id="element-27" />)}
          </div>
          <span className="text-xs text-[#8A7A6D] font-medium" data-id="element-28">
            {rating} ({reviews.toLocaleString()})
          </span>
        </div>

        {/* Title */}
        <h3 className="font-heading text-lg font-bold text-[#3D2C2C] mb-2 leading-snug line-clamp-2" data-id="element-29">
          {title}
        </h3>

        {/* Description */}
        <p className="text-[#5A4A4A] text-sm leading-relaxed mb-5 flex-1 line-clamp-2" data-id="element-30">
          {description}
        </p>

        {/* Price */}
        <div className="flex items-baseline gap-2 mb-4" data-id="element-31">
          <span className="text-2xl font-bold text-[#1C1008]" data-id="element-32">{price} USD</span>
          {comparePrice && <span className="text-sm text-[#8A7A6D] line-through font-medium" data-id="element-33">
              {comparePrice} USD
            </span>}
        </div>

        {/* Button */}
        <a href={href || '#'} target="_blank" rel="noopener noreferrer" className="w-full inline-flex items-center justify-center gap-2 bg-[#C17F3E] hover:bg-[#A66A32] text-white py-3.5 rounded-lg font-bold text-sm transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-[#C17F3E] focus:ring-offset-2" aria-label={`${buttonText} - ${title}`} data-id="element-34">
          {buttonText}
        </a>
      </div>
    </motion.article>;
}